import {Tab} from '../../tabs/tab';

export class EvaluationTab extends Tab {
    public constructor(tabName: string, isSelected = false) {
        super(tabName, tabName, isSelected);
    }
}
